import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f5f5f5', // Gris claro
                padding: 2,
                textAlign: 'center',
                borderTop: '1px solid #ddd',
            }}
        >
            <Typography variant="body2" color="textSecondary">
                © Pintative Ltd {currentYear}
            </Typography>
        </Box>
    );
};

export default Footer;